import { ShortCode } from '@highereducation/wordpress';
import {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
} from '@highereducation/hen-ui';
import { parseTruthy } from '../utils';

type TableShortcodeProps = {
  children?: React.ReactNode;
  'show-border'?: string;
  'stack-on-mobile'?: string;
  [key: string]: unknown;
};

export const TableShortcode: ShortCode<TableShortcodeProps> = {
  component: ({
    children,
    'show-border': showBorder,
    'stack-on-mobile': stackOnMobile,
  }) => (
    <Table
      showBorder={parseTruthy(showBorder)}
      stackOnMobile={
        stackOnMobile !== undefined ? parseTruthy(stackOnMobile) : true
      }
    >
      {children}
    </Table>
  ),
};

export const TableHeaderShortcode: ShortCode<TableShortcodeProps> = {
  component: ({ children }) => <TableHeader>{children}</TableHeader>,
};

export const TableBodyShortcode: ShortCode<TableShortcodeProps> = {
  component: ({ children }) => <TableBody>{children}</TableBody>,
};

export const TableFooterShortcode: ShortCode<TableShortcodeProps> = {
  component: ({ children }) => <TableFooter>{children}</TableFooter>,
};

export const TableRowShortcode: ShortCode<TableShortcodeProps> = {
  component: ({ children }) => <TableRow>{children}</TableRow>,
};

type TableHeadShortcodeProps = {
  colSpan?: string;
  scope?: string;
  children?: React.ReactNode;
  [key: string]: unknown;
};

export const TableHeadShortcode: ShortCode<TableHeadShortcodeProps> = {
  component: ({ colSpan, scope, children }) => (
    <TableHead colSpan={colSpan ? Number(colSpan) : undefined} scope={scope}>
      {children}
    </TableHead>
  ),
};

type TableCellShortcodeProps = {
  colSpan?: string;
  'data-title'?: string;
  children?: React.ReactNode;
  [key: string]: unknown;
};

export const TableCellShortcode: ShortCode<TableCellShortcodeProps> = {
  component: ({ colSpan, 'data-title': dataTitle, children }) => (
    <TableCell
      colSpan={colSpan ? Number(colSpan) : undefined}
      data-title={dataTitle}
    >
      {children}
    </TableCell>
  ),
};

export const TableCaptionShortcode: ShortCode<TableShortcodeProps> = {
  component: ({ children }) => <TableCaption>{children}</TableCaption>,
};
